var thisMainURL = window.location.pathname;
if(thisMainURL=="/collections" || thisMainURL=="/collections/" ){
  window.location.pathname="/collections/all";  
}
// Simulate an HTTP redirect:


jQuery(document).ready(function(){



var lastScrollTop1 = 0;
  
document.addEventListener("scroll", function(event){ // or window.addEventListener("scroll"....
   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    var doc = document.documentElement;
//var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
     
   if (st > lastScrollTop1) {
     if ((window.innerHeight*3 + window.scrollY) >= document.body.offsetHeight) {
      $(".load-more_wrap button.btn.js-load-more").trigger("click");
        //alert("set");
    }

   } else if (st < lastScrollTop1) {

     
   } // else was horizontal scroll
   lastScrollTop1 = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);
  

        
            $("body").on("touchstart",".gvs-icon-item.gvs-share-icon .gvs-social-hvr",function() {
             $(".gvs-icon-item.gvs-share-icon").toggleClass("active");
            });
        


$(document).mouseup(function(e) 
{
    var container = $("#FacetFiltersFormMobile .mobile-facets__inner");
    var triggerEle = $(".mobile-facets__disclosure.disclosure-has-popup.menu-opening summary");  
    // if the target of the click isn't the container nor a descendant of the container
    if (!triggerEle.is(e.target) && !container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".mobile-facets__disclosure.disclosure-has-popup.menu-opening").removeClass("menu-opening");
    }
});

  

$("slideshow-component .slideshow__slide").click(function(e){
   if(!$('body').hasClass('page-blog'))
  {
  e.stopPropagation();e.preventDefault();
    var thisurl = $(this).find(".banner__buttons a").attr("href");
  window.location.pathname=thisurl;
  }
});
  $("section.image-with-text>div,section.images-with-text>div").click(function(e){
  e.stopPropagation();e.preventDefault();
    var thisurl = $(this).find("a.button-v.button--primary,a.main-btn").attr("href");
  window.location.pathname=thisurl;
});

    $("body").on("click","#ProductGridContainer #product-grid>li.grid__item",function(e){
  e.stopPropagation();e.preventDefault();
    var thisurl = $(this).find("a.card__content-a").attr("href");
      if(thisurl.includes("?_pos")){
        var thisSPlit = thisurl.split("?");
        thisurl = thisSPlit[0];
      }
      console.log(thisurl);
  window.location.pathname=thisurl;
});
  $("body").on("mouseup","[data-wk-share-service='link']",function(e){
  e.stopPropagation();e.preventDefault();
    var thisLINK = "https://"+window.location.hostname+"/pages/shared-wishlist/"+$(this).attr("data-wk-share");
  navigator.clipboard.writeText(thisLINK);
     alert("Copied the link: " + thisLINK);
});
 
 
  

$("body").on("click",".page-width-blog slider-component .blog__postss>li.blog__postsss,.blog-articles__article",function(e){
  e.stopPropagation();e.preventDefault();
    var thisurl = $(this).find(".card__content .card__heading>a").attr("href");
  window.location.pathname=thisurl;
});  
    
 




  
var lastScrollTop = 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
document.addEventListener("scroll", function(event){ // or window.addEventListener("scroll"....
   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    var doc = document.documentElement;
//var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
var top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
     
     if(top>145.22){$("body").addClass("canFix");}else{$("body").removeClass("canFix");}
  
   if (st > lastScrollTop) {
      //console.log("scrolltop");
     $("body").removeClass("forFix");
   } else if (st < lastScrollTop) {
 $("body").addClass("forFix");
     
   } // else was horizontal scroll
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);
  
  $("#Details-HeaderMenu-1").attr("open",""); 
  $("#Details-HeaderMenu-1>summary").click(function (e) {
    e.preventDefault();
     $("#Details-HeaderMenu-1").attr("open","");  
    $("body").toggleClass("MenuOpened");
    $("#Details-HeaderMenu-1").toggleClass("open");
    if($("#Details-HeaderMenu-1[open]").length<1){
     $("#Details-HeaderMenu-1").attr("open","");  
    }
  });
 
var summary_gun=document.getElementById('Details-HeaderMenu-1').getElementsByTagName('summary')[0];
  window.addEventListener('click', function(e){   
  if ((document.getElementById('HeaderMenu-MenuList-1').contains(e.target)) || (summary_gun.contains(e.target))){
   
  } else{
   $("#Details-HeaderMenu-1").removeClass("open");
  // $("body:not(.MenuOpened) #Details-HeaderMenu-1").removeClass("open"); 
    $("body").removeClass("MenuOpened");
    
  }
});


  $("body").on("click",".gvsg-drawer-tabs .gvsg-drawer-tab",function(){
    var tabdata = $(this).attr("id"); //tabdata = tabdata.replace("-drawer","");
    $("#CartDrawer").attr("tab-type",tabdata);
  });
   $("body").on("mousedown","header .header__icons>a,.menu-drawer__utility-links a",function(){
    var tabdata = $(this).attr("data_id");
     $("#CartDrawer").attr("tab-type",tabdata);
     
  });


$("body").on("click","#Details-menu-drawer-container summary",function(){
  $("#Details-menu-drawer-container").addClass("active");$("body").addClass("menuOpened");
});
$("body").on("click",".menu-drawer__navigation .close-icon",function(){
  $("#Details-menu-drawer-container").removeClass("active");$("body").removeClass("menuOpened");
  $("body").removeClass("overflow-hidden-tablet");
});  
$("body").on("click",".gvsg-drawer-wishlist a.wk-product-image span.gv-cart-icon",function(e){
  e.stopPropagation(); e.preventDefault();
  
  
  $(this).closest(".wk-grid__item").find("form button.wk-product-form__submit").trigger("click");
});
$(".thumbnail-slider .slider.slider--mobile .slider__slide:nth-child(1)").addClass("active");
  var thisData = 1;
  $('.vv.slider-buttons .slider-counter--current').on('DOMSubtreeModified', function(){
    var currentlData = $(this).html(); currentlData = parseInt(currentlData);
    if(thisData!=currentlData){
  thisData = currentlData;
    $(".thumbnail-slider .slider.slider--mobile .slider__slide").removeClass("active");
    $(".thumbnail-slider .slider.slider--mobile .slider__slide:nth-child("+thisData+")").addClass("active");
    
      jQuery("slider-component.gvsZoomSlider").removeClass("zoomed");
    }
});
  $(".product__media-wrapper>media-gallery slider-component.slider-mobile-gutter modal-opener").on("mousedown",function(){
     thisData = $(this).closest("li").attr("jd");
    jQuery(".gvszoomThumbnails.thumbnail-slider .slider.slider--mobile .slider__slide:nth-child("+thisData+") button").trigger("click"); 
    setTimeout(function(){
      jQuery(".gvszoomThumbnails.thumbnail-slider .slider.slider--mobile .slider__slide:nth-child("+thisData+") button").trigger("click"); 
    },200);
  });

  jQuery(".product__modal-opener").on("mouseup",function() {
    jQuery(".gvszoomThumbnails.thumbnail-slider .slider.slider--mobile .slider__slide:nth-child("+thisData+") button").trigger("click"); 
    setTimeout(function(){
      jQuery(".gvszoomThumbnails.thumbnail-slider .slider.slider--mobile .slider__slide:nth-child("+thisData+") button").trigger("click"); 
    },200);
  })
  
  jQuery("body").on("mouseup","slider-component.gvsZoomSlider .product__media",function(e){
    e.stopPropagation();
    console.log($(this));
  jQuery("slider-component.gvsZoomSlider").toggleClass("zoomed");
    

    var outerContent = jQuery(this);
    var innerContent = $(this).find('img');

    outerContent.scrollTop((innerContent.height() - $(window).height()) / 2); 
    outerContent.scrollLeft((innerContent.width() - $(window).width()) / 2); 
});
});


